<h2 mat-dialog-title class="tw-font-semibold">Create Service Account</h2>

<mat-dialog-content class="tw-pt-4 tw-pb-0">
  <form [formGroup]="form" class="tw-space-y-4">
    <mat-form-field appearance="outline" class="tw-w-full">
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" required />
      <mat-error *ngIf="form.get('name')?.hasError('required')">Name is required</mat-error>
      <mat-hint>Descriptive name for this service account</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline" class="tw-w-full">
      <mat-label>Role</mat-label>
      <mat-select formControlName="role" required>
        <mat-option value="viewer">Viewer</mat-option>
        <mat-option value="editor">Editor</mat-option>
        <mat-option value="admin">Admin</mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('role')?.hasError('required')">Role is required</mat-error>
      <mat-hint>Access level for this service account</mat-hint>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="tw-px-6 tw-py-5">
  <button mat-stroked-button (click)="close()">Cancel</button>
  <button
    mat-raised-button
    [disabled]="!form.valid"
    color="primary"
    (click)="save()"
    class="disabled:tw-border-gray-400 disabled:tw-text-gray-400 disabled:tw-cursor-not-allowed">
    Create
  </button>
</mat-dialog-actions>
